// Evenly spaced hues around the wheel, picked deterministically from the name so two people read as
// clearly different and everyone keeps the same color everywhere.
const AVATAR_HUES = [0, 20, 40, 60, 80, 100, 120, 140, 160, 180, 200, 220, 240, 260, 280, 300, 320, 340];

// The name also picks how light the fill is, which in turn decides the text color: a deep fill takes
// white, a pale one takes near-black. The gap between the two is deliberate — every lightness in
// between is too middling for either text color to clear WCAG AA.
const AVATAR_TONES = [
  { lightness: 0.5, color: '#ffffff' },
  { lightness: 0.78, color: 'var(--color-neutral-900)' },
];

// A polynomial rolling hash, folded by a large prime each step so it stays a small safe integer.
// Position-sensitive, so "Jan Peeters" and "Peeters Jan" do not collide.
const HASH_MODULUS = 100003;

export default function avatarColor(name) {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = (hash * 31 + name.charCodeAt(i)) % HASH_MODULUS;
  }
  const hue = AVATAR_HUES[hash % AVATAR_HUES.length];
  const tone = AVATAR_TONES[Math.floor(hash / AVATAR_HUES.length) % AVATAR_TONES.length];
  return { background: `oklch(${tone.lightness} 0.16 ${hue})`, color: tone.color };
}
